import styled from 'styled-components'

export const Form = styled.form`
  position: relative;
  width: 100%;
`

export const FormFields = styled.form`
  display: flex;
  flex-flow: column nowrap;
  gap: 24px;
`

export const Container = styled.div`
  a {
    color: var(--cobasi-blue-light-9);
    font-size: 14px;
    font-weight: 600;
    font-family: var(--primary-font);
    cursor: pointer;
    > div {
      text-align: start;
    }
  }
`
